import { BaseError } from "./BaseError";

export class MethodNotAllowedError extends BaseError {
  readonly status = 405;
}
